module.exports = __webpack_public_path__ + "static/img/app6.6e636b68.png";